// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rootCategory":"rootCategory_OqUiS mx-auto px-[2%] pb-5 w-full max-w-[1018px] text-[0.75rem] lg_px-5 lg_block lg_max-w-[1018px] xl_w-[1024px] xl_max-w-full"};